export const listadoMaterias = [
  {
    nombreMateria: "Algebra I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Análisis Matemático I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Introducción a la Programación I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Química",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Algebra Lineal",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Ciencias de la Computación I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Física General",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Introducción a la Programación II",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Matemática Discreta",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Análisis Matemático II",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Análisis y Diseño de Algoritmos I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Ciencias de la Computación II",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Electricidad y Magnetismo",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Introducción a la Arquitectura de Sistemas",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Análisis y Diseño de Algoritmos II",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Comunicación de Datos I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Electrónica Digital",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Probabilidades y Estadística",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Arquitectura de Computadoras I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Estructuras de Almacenamiento de Datos",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Metodologías de Desarrollo de Software I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Programación Orientada a Objetos",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Bases de Datos I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Investigación Operativa I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Sistemas Operativos I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Arquitectura de Computadoras y Técnicas Digitales ",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Programación Exploratoria",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Comunicación de Datos II",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Diseño de Sistemas de Software",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Ingeniería de Software",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Lenguajes de Programación I",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Introducción al Cálculo Diferencial e Integral",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Teoría de la Información",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Diseño de Compiladores I",
    condicion: "Aprobada pasada",
  },
];

export const listadoOptativas = [
  {
    nombreMateria: "Inglés",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Legislación y Gestión Ambiental",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Fundamentos de Economía y Proyectos de Inversión",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Organización Empresarial",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Introduccion a la Programacion de Dispositivos Moviles",
    condicion: "Aprobada pasada",
  },

  {
    nombreMateria: "Diseño de Interaccion Centro al Usuario",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Taller de Programación Java",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Autonomia e Inteligencia Artificial",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Metodologias Agiles",
    condicion: "Aprobada pasada",
  },
];

export const listadoReferencias = [
  {
    nombreMateria: "Cursada y final aprobadas",
    condicion: "Aprobada pasada",
  },
  {
    nombreMateria: "Final pendiente",
    condicion: "Final restante",
  },
];

export const wavesReciclajeTandil = [
  {
    d: "m 203 0 c -70,30 -350,40 0,200 ",
    idGradiente: "gradiente1",
    coloresGradientes: ["#151d30", "#1c2c43", "#273951"],
  },
  {
    d: "m 203 50 c 0,100 -350,60 0,180",
    idGradiente: "gradiente2",
    coloresGradientes: ["#139d8d", "#139d8d", "#36ec7e"],
  },
  {
    d: "m 203 10 c -100,40 -100,30  0,80",
    idGradiente: "gradiente3",
    coloresGradientes: ["#ffa601", "#ff7d43", "#f95d6a", "#d55087", "#a05095"],
  },
];

export const wavesRedisenoWebBacMono = [
  {
    d: "m 203 0 c -160,20 -350,120 0,200 ",
    idGradiente: "gradiente4",
    coloresGradientes: ["#dcdcdc", "#dcdcdc", "#c1c1c1"],
  },
  {
    d: "m 203 -10 c -260,20 -225,0 0,80",
    idGradiente: "gradiente5",
    coloresGradientes: ["#000000", "#161616", "#2f2f2f"],
  },
  {
    d: "m 203 40 c -30,40 -30,40  0,70",
    idGradiente: "gradiente6",
    coloresGradientes: ["#e40202", "#f8230d", "#e34539"],
  },
  {
    d: "m 203 90 c -30,40 -30,40  0,70",
    idGradiente: "gradiente7",
    coloresGradientes: ["#a7977d", "#736551", "#473d2f"],
  },
  {
    d: "m 203 140 c -30,40 -30,40  0,70",
    idGradiente: "gradiente8",
    coloresGradientes: ["#03a9f4", "#52c4f7", "#8bd8fc"],
  },
];

export const wavesReemplazoDeSmartphone = [
  {
    d: "m 203 0 c -70,80 -380,30 0,200 ",
    idGradiente: "gradiente9",
    coloresGradientes: [
      "#1ab99a",
      "#1e9483",
      "#22716c",
      "#264b53",
      "#253442",
      "#22303d",
    ],
  },
];

export const wavesAlgoritmoDeTrazas = [
  {
    d: "m 203 0 c -70,80 -380,30 0,200 ",
    idGradiente: "gradiente10",
    coloresGradientes: ["#2C323A", "#353B46", "#3C424E", "#424855", "#474E5C"],
  },
  {
    d: "m 203 50 c 0,100 -350,60 0,180",
    idGradiente: "gradiente11",
    coloresGradientes: ["#C66EC7", "#C176D2", "#BC7EDD", "#B787E9"],
  },
];

export const wavesSincronizacionSistemaGestionTiendaOnline = [
  {
    d: "m 203 -10 c -60,80 -310,30 0,200 ",
    idGradiente: "gradiente12",
    coloresGradientes: ["#CF3AA7", "#C549A7", "#B652A5", "#894799", "#292F81"],
  },
  {
    d: "m 203 50 c 0,100 -250,60 0,180",
    idGradiente: "gradiente13",
    coloresGradientes: ["#2C3357", "#2D3458"],
  },
];

export const wavesGestureCalculator = [
  {
    d: "m 203 0 c -160,20 -350,120 0,200 ",
    idGradiente: "gradiente14",
    coloresGradientes: ["#CAE8D5", "#3B6978", "#204051"],
  },
];

export const wavesRKIntroCalculoDiferencial = [
  {
    d: "m 203 0 c -70,80 -380,30 0,200",
    idGradiente: "gradiente15",
    coloresGradientes: ["#002282", "#0648b3"],
  },
  {
    d: "m 203 30 c -100,40 -100,30  0,80",
    idGradiente: "gradiente16",
    coloresGradientes: ["#ff6858", "#eb2d2d", "#b00004"],
  },
];

export const portfolioReciclajeTandil = {
  titulo: "Reciclaje Tandil App",
  urlTecnologias: ["android-icon.png", "java-icon.png"],
  descripcion:
    "Aplicación Android que permite visualizar y administrar los elementos reciclados de un usuario",
  descripcionExtendida: [
    "Este proyecto corresponde al trabajo final de la materia “Introducción a la Programación de Dispositivos Móviles” de la carrera de Ingeniería de Sistemas de la Universidad Nacional del Centro de la Provincia de Buenos Aires y consta en el desarrollo de una aplicación para android, la cual permite visualizar y manejar los reciclados de un usuario. Dicha aplicación se conecta con un servidor provisto por la cátedra el cual permite, almacenar nuevos usuarios, almacenar nuevos reciclados y consultar la lista y total de reciclados de un usuario dado.",
  ],
  participacion: [
    "Mi participación dentro del proyecto consto en el diseño e implementación de cada una de las vistas que componen la aplicación, cumpliendo con las consignas de la cátedra y teniendo en cuenta que debía ser lo suficientemente intuitiva para ser utilizada por usuarios inexpertos. \n Además se tuvieron en cuenta normativas de diseño “Material Design” sugeridas por Google.",
  ],
  desarrollo:
    "La implementación del proyecto fue realizada en forma íntegra en el lenguaje de programación Java.",
  linkRepositorio:
    "https://bitbucket.org/carreterosanti/reciclados-tandil-tp-final-moviles/src/master/",
  urlImagenes: [
    "./recicladosTandilScreenshot1.png",
    "./recicladosTandilScreenshot2.png",
    "./recicladosTandilScreenshot3.png",
    "./recicladosTandilScreenshot4.png",
    "./recicladosTandilScreenshot5.png",
    "./recicladosTandilScreenshot6.png",
    "./recicladosTandilScreenshot7.png",
    "./recicladosTandilScreenshot8.png",
  ],
  wave: wavesReciclajeTandil,
  linkWeb: "",
};

export const portfolioRedisenoWebBacMono = {
  titulo: "Rediseño Web Bac Mono",
  urlTecnologias: ["react-icon.png", "js-icon.png", "css-icon.png"],
  descripcion:
    "Rediseño del inicio de la página web correspondiente a la empresa británica de fabricación de superdeportivos BAC",
  descripcionExtendida: [
    "El objetivo de este proyecto fue experimentar desarrollando con la librería React y el módulo de CSS “flexbox”.",
    "Comencé rediseñando la barra de navegación haciéndola más simple y extendida, luego con el objetivo de evitar el clásico carrusel de fotos presente en todos los sitios web de marcas de automóviles, pero respetando la información presentada en la versión original del sitio web, opte por una grilla compuesta por 4 cuadrantes para presentar la información.",
    "Esto último además permite integrar las opciones que muestran ciertos elementos de la barra de navegación en la sección izquierda de la grilla.",
  ],
  linkRepositorio:
    "https://github.com/carreterosanti/Bac-Mono-Redesign-Website",
  urlImagenes: [
    "./redesignVersionBacMono1.png",
    "./redesignVersionBacMono2.png",
  ],
  participacion: [],
  desarrollo:
    "La creación y configuración del proyecto fue realizado mediante el paquete de npm “create-react-app”. Luego la implementación del mismo fue desarrollado en forma íntegra utilizando la librería React.",
  wave: wavesRedisenoWebBacMono,
  linkWeb: "https://carreterosanti.github.io/Bac-Mono-Redesign-Website/",
};

export const portfolioGestureCalculator = {
  titulo: "Calculadora Gestual Web",
  urlTecnologias: ["react-icon.png", "js-icon.png", "css-icon.png"],
  descripcion:
    'Herramienta web la cual provee una calculadora que permite sumar y restar, controlando dichas operaciones mediante "Drag and Drop" (Cursor) o "Swipe" (Táctil) directamente sobre los números del teclado.',
  descripcionExtendida: [
    'Herramienta web la cual provee una calculadora que permite sumar y restar, controlando dichas operaciones mediante "Drag and Drop" (Cursor) o "Swipe" (Táctil) directamente sobre los números del teclado.',
    'El objetivo de la herramienta es ofrecer una interfaz conveniente para realizar cuentas rápidas de suma y resta, con números de un solo dígito. Esto es factible, ya que el conjunto “dígito y operador” se indica en una misma acción de "Drag and Drop" (Cursor) o "Swipe" (Táctil). ',
  ],
  linkRepositorio: "https://github.com/carreterosanti/gesture-calculator",
  urlImagenes: [
    "./gesture-calculator-mobile-screenshot.png",
    "./gesture-calculator-screenshot.png",
  ],
  participacion: [],
  desarrollo:
    "El desarrollo del proyecto se realizó mediante React.js, partiendo desde la estructura inicial que provee la herramienta “Create React App”. Se puede destacar la implementación de un Context para almacenar los valores correspondientes del “Resultado Final” y “Dígitos Parciales”. Por último cabe mencionar que se utilizó en la implementación React Router Dom para el acceso a la vista de “introducción a la calculadora”.",
  wave: wavesGestureCalculator,
  linkWeb: "https://carreterosanti.github.io/gesture-calculator/",
};

export const portfolioReemplazoDeSmartphone = {
  titulo: "Reemplazo de Smartphone",
  urlTecnologias: ["java-icon.png", "java-fx-icon.png"],
  descripcion:
    "Aplicación de escritorio que ofrece al usuario sugerencias de reemplazo de su smartphone dado un presupuesto y prioridad de características indicadas por el usuario",
  descripcionExtendida: [
    "Este trabajo corresponde al proyecto evaluador final de la materia “Investigación Operativa” de la carrera de Ingeniería de Sistemas de la Universidad Nacional del Centro de la Provincia de Buenos Aires y consta en el desarrollo de una herramienta, con el objetivo de analizar mediante el método AHP el posible reemplazo de un dispositivo móvil, partiendo de cierto valor compuesto por: precio de reventa del dispositivo actual + inversión deseada. Luego, identificando la prioridad del usuario de las distintas características de un dispositivo móvil y concluyendo en un podio de 3 dispositivos que mejor se ajustan a las preferencias y presupuesto del usuario.",
  ],
  participacion: [
    "Mi participación dentro del proyecto consto en el diseño e implementación de cada una de las vistas e interacciones que componen la herramienta.",
    "Además realice la implementación de la funcionalidad de recolección de datos mediante la técnica de “Web Scraping”, utilizando la librería Jsoup para Java. Esto permite obtener los datos actualizados del valor de reventa, valor en condiciones de nuevo, fecha de lanzamiento del smartphone y el puntaje de review de cada uno de los smartphones involucrados.",
  ],
  urlImagenes: [
    "./reemplazoDeSmartphone1.png",
    "./reemplazoDeSmartphone2.png",
    "./reemplazoDeSmartphone3.png",
    "./reemplazoDeSmartphone4.png",
  ],
  linkRepositorio:
    "https://bitbucket.org/carreterosanti/tpinvestigacionoperativa/src/master/",
  desarrollo:
    "El back-end de la aplicación fue desarrollado en forma íntegra en el lenguaje de programación Java, mientras que el front-end fue implementado mediante la herramienta “JavaFX Scene Builder”.",

  wave: wavesReemplazoDeSmartphone,
  linkWeb: "",
};

export const portfolioAlgoritmoDeTrazas = {
  titulo: "Algoritmo de Trazas",
  urlTecnologias: ["java-icon.png", "angular-icon.png"],
  descripcion:
    "Herramienta web que permite analizar la dependencia de datos a partir de un código fuente correspondiente a una iteración",
  descripcionExtendida: [
    "En este trabajo corresponde a un proyecto evaluador final de la materia “Arquitectura de Computadores y Técnicas Digitales” de la carrera Ingeniería de Sistemas de la Universidad Nacional de Centro de la Provincia de Buenos Aires y consta en el desarrollo de una herramienta web, con el objetivo de analizar la dependencia de datos a partir de un código fuente correspondiente a una iteración.",
    "Dicha herramienta analiza el código fuente, genera un grafo denominado “Grafo Temporal” a partir de las dependencia de datos de tipo RAW y detecta las trazas que contienen ciclos y/o bucles.",
  ],
  participacion: [
    "Mi participación dentro del proyecto constó en la implementación de las siguientes funcionalidades del back-end: análisis léxico y verificación sintáctica del código fuente provisto por el usuario, análisis de las sentencias reconociendo las variables definidas y dependencias entre ellas, generación del grafo de dependencias temporal, algoritmo de reconocimiento de trazas con ciclos o bucles.",
    "Además también participe en el diseño final del front-end definiendo el layout y flujo de utilización de la herramienta.",
  ],
  desarrollo:
    "El desarrollo del back-end fue realizado en el lenguaje de programación Java, mientras que el fron-end fue implementado utilizando el framework AngularJS. Estos se comunican entre sí mediante servicios REST.",
  linkRepositorio:
    "https://bitbucket.org/tpfinaltolozacarretero/mavenmaster/src/master/",
  urlImagenes: ["./algoritmoDeTrazas.png"],
  wave: wavesAlgoritmoDeTrazas,
  linkWeb: "https://trazasapplication.herokuapp.com/",
};

export const portfolioSincronizacionSistemaGestionTiendaOnline = {
  titulo: "Sincronización de Sistema Gestión y Tienda Online",
  urlTecnologias: ["java-icon.png"],
  descripcion:
    "Aplicación Java para la sincronización automática de ventas y artículos, entre el sistema de gestión Centum Suite y una tienda online de Tienda Nube",
  descripcionExtendida: [
    "Aplicación desarrollada para una empresa privada, la cual deseaba sincronizar automáticamente en forma periódica, las ventas y artículos de su tienda online de Tienda Nube, con su sistema de gestión Centum Suite.",
    "La aplicación obtiene la información necesaria mediante las API que Centum Suite y Tienda Nube proveen, para luego analizar, procesar y actualizar los valores de stock y precio de todos los artículos presentes en la tienda online. Así como también informa al sistema de gestión, Centum Suite, de las ventas realizadas en Tienda Nube.",
    "Cada sincronización se notifica mediante un correo electrónico, donde se muestra en detalle la actualización de cada artículo y/o venta.",
  ],
  participacion: [
    "Mi participación dentro del proyecto comprendió desde la captura de requerimientos, diseño, implementación y configuración para la ejecución automática de la aplicación.",
  ],
  desarrollo:
    "El desarrollo de la aplicación se realizó en forma íntegra en Java.",
  linkRepositorio: "",
  urlImagenes: ["./centum-tiendanube.png"],
  wave: wavesSincronizacionSistemaGestionTiendaOnline,
  linkWeb: "",
};

export const portfolioRKIntroCalculoDiferencial = {
  titulo: "Implementación Método Numérico Runge-Kutta",
  urlTecnologias: ["vue-icon.png", "js-icon.png"],
  descripcion:
    "Implementación del método numérico Runge-Kutta y visualización de resultados, aplicado a sistema de ecuaciones diferenciales.",
  descripcionExtendida: [
    "Este proyecto corresponde a la sección de promoción del segundo trabajo práctico especial de la materia “Introducción al Cálculo Diferencial e Integral” de la carrera de Ingeniería de Sistemas de la una Universidad Nacional del Centro de la Provincia de Buenos Aires. El mismo consta en la implementación del método numérico Runge Kutta, con el objetivo de verificar en forma numérica los resultados obtenidos en el mencionado segundo trabajo práctico especial.",
    "La herramienta permite visualizar las tablas y gráficos obtenidos de aplicar el método numérico a los tres escenarios analizados: “Vibraciones Libres”, “Vibraciones Libres Amortiguadas” y “Vibraciones Forzadas Amortiguadas”. ",
  ],
  participacion: [
    "Mi participación dentro del proyecto comprendió el desarrollo íntegro del mismo.",
  ],
  desarrollo:
    "El desarrollo del proyecto fue realizado utilizando: Vue.js, BootstrapVue y vue-chartjs. Por otro lado, el hosting del sitio se realiza mediante la plataforma de Google: Firebase.",
  linkRepositorio:
    "https://github.com/carreterosanti/unicen-rk4-sistema-ecuaciones",
  urlImagenes: ["./rk4-unicen-screenshot.png"],
  wave: wavesRKIntroCalculoDiferencial,
  linkWeb: "https://unicen-rk4-sistema-ecuaciones.web.app/",
};

export const listadoProyectosPortfolio = [
  portfolioRKIntroCalculoDiferencial,
  portfolioSincronizacionSistemaGestionTiendaOnline,
  portfolioGestureCalculator,
  portfolioRedisenoWebBacMono,
  portfolioReciclajeTandil,
  portfolioAlgoritmoDeTrazas,
  portfolioReemplazoDeSmartphone,
];
